import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sdHighlight',
  standalone: true,
})
export class SdHighlightTextPipe implements PipeTransform {
  transform(value: string | null, toFind: string): string | null {
    if (!value || !toFind) {
      return value;
    }
    const findTextRegex = new RegExp(toFind, 'gi');
    return value.replace(findTextRegex, '<mark>$&</mark>');
  }
}
